// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"939a5f7a","453":"079ea098","455":"740bae9b"}[chunkId] + ".chunk.js";
};